import { ControlledModal } from 'components/ControlledModal';
import { useState } from 'react';
import { MediaSequenceCreateNew } from './Create/MediaSequenceCreateNew';
import { MediaSequenceCreate } from './MediaSequenceCreate';
import { twMerge } from 'tailwind-merge';
import { AnimatedIcon } from 'components/Icon/AnimatedIcon';

// TODO: Ideally this should also support "folderId", "caseId", etc as a prop,
// But MediaSequenceCreateNew doesn't support it.

interface MediaSequenceCreateProps {
  trigger?: React.ReactNode;
}

enum EMediaSequenceSetupMode {
  Fixed = 'fixed',
  Dynamic = 'dynamic',
}

export const MediaSequenceCreateSelector = ({
  trigger,
}: MediaSequenceCreateProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [mediaSequenceMode, setMediaSequenceMode] = useState<
    EMediaSequenceSetupMode | undefined
  >(undefined);

  const onModalStateChange = (state: boolean) => {
    setIsOpen(state);
  };

  const selectMode = (mode: EMediaSequenceSetupMode) => {
    setMediaSequenceMode(mode);
    setIsOpen(false);
  };

  return (
    <>
      {mediaSequenceMode === EMediaSequenceSetupMode.Fixed ? (
        <MediaSequenceCreate
          isInitialOpen={true}
          onClosed={() => {
            setMediaSequenceMode(undefined);
          }}
        />
      ) : null}

      {mediaSequenceMode === EMediaSequenceSetupMode.Dynamic ? (
        <MediaSequenceCreateNew
          isInitialOpen={true}
          onClosed={() => {
            setMediaSequenceMode(undefined);
          }}
        />
      ) : null}

      {trigger ? (
        <div onClick={() => onModalStateChange(true)}>{trigger}</div>
      ) : null}
      <ControlledModal
        showModal={onModalStateChange}
        isOpen={isOpen}
        title={'Opret video'}
        closeOnOutsideClick
        hideActionBar
      >
        <div className="w-full relative">
          <div className="flex flex-col gap-4 sm:flex-row">
            <div
              className={twMerge(
                mediaSequenceMode === EMediaSequenceSetupMode.Fixed
                  ? 'bg-gray-200 border-primary ring-2 ring-primary'
                  : 'bg-white',
                'w-full sm:w-1/2 flex flex-col items-center justify-center p-4 border border-gray-300 rounded-lg sm:rounded-l-lg cursor-pointer transition-all duration-150 hover:bg-gray-100 focus:outline-none'
              )}
              tabIndex={0}
              onClick={() => selectMode(EMediaSequenceSetupMode.Fixed)}
            >
              <AnimatedIcon
                icon="template-icon"
                className="w-14 h-14 mb-2"
                autoPlay
              />
              <p className="font-semibold text-base">Fast</p>
              <span className="text-xs text-gray-500 text-center mt-1">
                Vælg en allerede oprettet skabelon, der er klar til brug.
                Perfekt til boligpræsentationer, solgt-videoer og lignende.
              </span>
            </div>
            <div
              className={twMerge(
                mediaSequenceMode === EMediaSequenceSetupMode.Dynamic
                  ? 'bg-gray-200 border-primary ring-2 ring-primary'
                  : 'bg-white',
                'w-full sm:w-1/2 flex flex-col items-center justify-center p-4 border border-gray-300 rounded-lg sm:rounded-r-lg cursor-pointer transition-all duration-150 hover:bg-gray-100 focus:outline-none relative'
              )}
              tabIndex={0}
              onClick={() => selectMode(EMediaSequenceSetupMode.Dynamic)}
            >
              <div className="absolute top-2 right-2 bg-primary text-white text-xs font-bold px-2 py-0.5 rounded-full shadow-lg">
                NY
              </div>
              <AnimatedIcon
                icon="sliders-icon"
                className="w-14 h-14 mb-2"
                autoPlay
              />
              <p className="font-semibold text-base">Dynamisk</p>
              <span className="text-xs text-gray-500 text-center mt-1">
                Sæt selv videoen sammen med de elementer, du ønsker. Ideel, når
                du vil tilpasse udtrykket.
              </span>
            </div>
          </div>
        </div>
      </ControlledModal>
    </>
  );
};
